import { Component, OnInit, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Additive } from "../../../../models/Additive.model";
import { CommonHelper } from "../../../../shared/helpers/CommonHelper";

@Component({
    selector: 'app-modal-input-value',
    templateUrl: './modal-input-value.component.html',
    styleUrls: ['./modal-input-value.component.scss']
})
export class ModalInputAdditiveValueComponent implements OnInit {
    @Input() additive: Additive;
    @Output() sendAdditiveSoldHourValue = new EventEmitter<any>();
    currencyMaskOptions;
    constructor(
        public commonHelper: CommonHelper,
    ) {}

    async ngOnInit(): Promise<void> {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.currencyMaskOptions = {
            ...this.commonHelper.getConfigurationMaskMoney(),
            align: 'left'
        }
    };

    save() {
        if (this.additive.soldHourValue > 0) {
            this.sendAdditiveSoldHourValue.emit(this.additive);
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/components/modalInputAdditiveValue/modal-input-value.component.ts